import { QueryBuilderClassNames } from 'angular2-query-builder';

export const queryBuilderClassNames: QueryBuilderClassNames = {
  removeIcon: 'pi pi-trash',
  addIcon: 'fa fa-plus',
  arrowIcon: 'fa fa-chevron-right px-2',
  button: 'btn',
  buttonGroup: 'btn-group',
  rightAlign: 'order-12 ml-auto',
  switchRow: 'd-flex px-2',
  switchGroup: 'd-flex align-items-center',
  switchRadio: 'custom-control-input',
  switchLabel: 'custom-control-label',
  switchControl: 'custom-control custom-radio custom-control-inline',
  row: 'row px-2 pb-2 mx-1 mb-1',
  rule: '',
  ruleSet: '',
  invalidRuleSet: 'alert alert-danger',
  emptyWarning: 'text-danger mx-auto',
  operatorControl: 'form-control',
  operatorControlSize: 'ml-4',
  fieldControl: 'form-control',
  fieldControlSize: 'ml-2',
  entityControl: 'form-control',
  entityControlSize: 'ml-2',
  inputControl: 'form-control',
  inputControlSize: 'ml-2'
};
